var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22175 11.6313L27.2445 6.03639C29.2958 5.49039 31.4034 6.69949 31.9518 8.73585L32.7321 11.6275H34.5938C36.7168 11.6275 38.4375 13.3368 38.4375 15.4457C38.4375 19.6088 38.4375 27.828 38.4375 31.9911C38.4375 34.1 36.7168 35.8093 34.5938 35.8093C28.3887 35.8093 12.6113 35.8093 6.40625 35.8093C4.28322 35.8093 2.5625 34.1 2.5625 31.9911C2.5625 27.828 2.5625 19.6088 2.5625 15.4457C2.5625 13.3991 4.18456 11.728 6.22175 11.6313ZM35.875 19.2639V15.4457C35.875 14.7431 35.301 14.1729 34.5938 14.1729H6.42931H6.41778H6.38831C5.68875 14.1819 5.125 14.7482 5.125 15.4457C5.125 19.6088 5.125 27.828 5.125 31.9911C5.125 32.6937 5.699 33.2639 6.40625 33.2639C12.6113 33.2639 28.3887 33.2639 34.5938 33.2639C35.301 33.2639 35.875 32.6937 35.875 31.9911V28.1729H26.9062C26.2272 28.1729 25.575 27.9044 25.0946 27.4271C24.6141 26.9499 24.3438 26.302 24.3438 25.6275C24.3438 24.5189 24.3438 22.9179 24.3438 21.8093C24.3438 21.1348 24.6141 20.4869 25.0946 20.0097C25.575 19.5324 26.2272 19.2639 26.9062 19.2639H35.875ZM26.9062 21.8093V25.6275H35.875V21.8093H26.9062ZM30.0799 11.6275L29.4777 9.39513C29.2945 8.71549 28.5911 8.31331 27.9082 8.49531L16.1386 11.6275H30.0799Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.43913b3de3dbefb96ae91f6a9898188a.svg";
export { ForwardRef as ReactComponent };